import { render, staticRenderFns } from "./Wheat.vue?vue&type=template&id=775f4d12&scoped=true&"
import script from "./Wheat.vue?vue&type=script&lang=js&"
export * from "./Wheat.vue?vue&type=script&lang=js&"
import style0 from "./Wheat.vue?vue&type=style&index=0&id=775f4d12&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "775f4d12",
  null
  
)

export default component.exports